import React, { useState, useEffect } from "react";
import {
    Typography,
    Button,
    Box,
    Chip,
} from "@mui/material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ModalNotificacao from "./ModalNotificacao";
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import axios from "axios";
import { MascaraCartaoCredito } from "../../../utils/MascaraCartaoCredito";
import { MascaraDataCartaoCredito } from "../../../utils/MascaraDataCartaoCredito";
import HomeIcon from '@mui/icons-material/Home';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { Breadcrumbs, Link } from "@mui/material";
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import PaymentIcon from '@mui/icons-material/Payment';
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const tituloSecaoSx = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase", mb: 1.5 };

const botaoPrincipalSx = { textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", px: 2.5, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } };
const botaoSecundarioSx = { textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } };

const OPCOES_PAGAMENTO = [
    {
        value: "BOLETO",
        titulo: "Boleto Bancário",
        descricao: "Receba o boleto por e-mail a cada vencimento.",
        Icone: ReceiptLongOutlinedIcon,
    },
    {
        value: "CREDIT_CARD",
        titulo: "Cartão de Crédito",
        descricao: "Cobrança automática no cartão a cada vencimento.",
        Icone: CreditCardIcon,
    },
];

const nomeMetodo = (valor) => OPCOES_PAGAMENTO.find((opcao) => opcao.value === valor)?.titulo;

const CARTAO_VAZIO = { name: "", number: "", expiry: "", cvv: "" };

const MetodoPagamento = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [assinatura, setAssinatura] = useState(null);
    const [showBack, setShowBack] = useState(false);
    const [salvando, setSalvando] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");

    const [cardData, setCardData] = useState(CARTAO_VAZIO);
    const [cardErrors, setCardErrors] = useState({});
    const [selectedValue, setSelectedValue] = useState('');

    const metodoAtual = user?.assinatura?.metodoPagamento;
    const possuiFaturasEmAberto = user?.faturas?.pendentes?.length > 0 || user?.faturas?.vencidas?.length > 0;
    // Já paga com cartão e quer trocar por outro cartão
    const trocandoCartao = selectedValue === "CREDIT_CARD" && metodoAtual === "CREDIT_CARD";
    const cartaoPreenchido = Object.values(cardData).some((valor) => valor.trim() !== "");

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;
        setUserActive(!hasFaturasVencidas);
        setSelectedValue(user?.assinatura?.metodoPagamento || '');
        if (user?.assinatura?.metodoPagamento === "CREDIT_CARD") {
            OPCOES_PAGAMENTO[1].bandeiraCartao = user?.dadosCartao?.bandeiraCartao || "VISA";
            OPCOES_PAGAMENTO[1].ultimosDigitosCartao = user?.dadosCartao?.ultimosDigitosCartao || "1234";
            OPCOES_PAGAMENTO[1].mesValidadeCartao = user?.dadosCartao?.mesValidadeCartao || "08";
            OPCOES_PAGAMENTO[1].anoValidadeCartao = user?.dadosCartao?.anoValidadeCartao || "2029";
        }
    }, [user, openSnackbarSuccess]);

    useEffect(() => {
        const getPlano = async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/buscarPlano`,
                {},
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                }
            );
            if (response.data.status === 200) {
                setAssinatura(response.data.assinatura);
            }
        };

        getPlano();
    }, []);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/buscarNotificacoes`,
                { email: localStorage.getItem("email") },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                }
            );

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes);
            }
        };

        getNotify();
    }, []);

    const handleChange = (event) => {
        setSelectedValue(event.target.value);
    }

    const handleCardInputChange = (e) => {
        setCardData({ ...cardData, [e.target.name]: e.target.value });
    };

    const validateCardData = (data) => {
        const errors = { valid: true };

        // Nome no cartão (mínimo 3 caracteres, apenas letras e espaços)
        if (!data.name.trim()) {
            errors.name = "O nome no cartão é obrigatório";
            errors.valid = false;
        } else if (!/^[a-zA-ZÀ-ÿ\s]{3,}$/.test(data.name)) {
            errors.name = "Nome inválido";
            errors.valid = false;
        }

        // Número do cartão (somente números, entre 13 e 19 dígitos)
        const cleanNumber = data.number.replace(/\s+/g, "");
        if (!cleanNumber) {
            errors.number = "O número do cartão é obrigatório";
            errors.valid = false;
        } else if (!/^\d{13,19}$/.test(cleanNumber)) {
            errors.number = "Número de cartão inválido";
            errors.valid = false;
        }

        // Validade (MM/YYYY)
        if (!data.expiry) {
            errors.expiry = "A data de validade é obrigatória";
            errors.valid = false;
        } else if (!/^(0[1-9]|1[0-2])\/\d{4}$/.test(data.expiry)) {
            errors.expiry = "Formato inválido (MM/AAAA)";
            errors.valid = false;
        } else {
            const [month, year] = data.expiry.split("/");
            const now = new Date();
            const expiryDate = new Date(year, month); // mês/ano do cartão
            if (expiryDate < now) {
                errors.expiry = "Cartão vencido";
                errors.valid = false;
            }
        }

        // CVV (3 ou 4 dígitos)
        if (!data.cvv) {
            errors.cvv = "O CVV é obrigatório";
            errors.valid = false;
        } else if (!/^\d{3,4}$/.test(data.cvv)) {
            errors.cvv = "CVV inválido";
            errors.valid = false;
        }

        return errors;
    };

    const mostrarErro = (texto) => {
        setMensagem(texto);
        setOpenSnackbarError(true);
    };

    const handleChangePaymentMethod = async () => {
        let errors = { valid: true };
        if (possuiFaturasEmAberto) {
            mostrarErro("Não é possível alterar o método de pagamento com faturas pendentes ou vencidas.");
            return;
        }
        if (selectedValue === "CREDIT_CARD") {
            errors = validateCardData(cardData);
        }
        setCardErrors(errors);

        if (!errors.valid) return;

        setSalvando(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/alterarMetodoPagamento`, {
                assinatura,
                idAssinatura: assinatura.id,
                idCustomer: assinatura.customer,
                value: assinatura.value,
                description: assinatura.description,
                nextDueDate: assinatura.nextDueDate,
                metodoPagamento: selectedValue,
                cardData: selectedValue === "CREDIT_CARD" ? cardData : null,
            },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`,
                    },
                }
            );
            if (response.data.status === 200) {
                fetchUser();
                setMensagem("Método de pagamento alterado com sucesso!");
                setOpenSnackbarSuccess(true);
                setCardData(CARTAO_VAZIO);
            } else {
                console.log(response.data);
                mostrarErro("Erro ao alterar método de pagamento. Tente novamente mais tarde.");
            }
        } catch (error) {
            console.error("Erro ao alterar método de pagamento:", error);
            mostrarErro("Erro ao alterar método de pagamento. Tente novamente mais tarde.");
        } finally {
            setSalvando(false);
        }
    };

    const faceCartao = {
        position: "absolute",
        inset: 0,
        backfaceVisibility: "hidden",
        background: "linear-gradient(135deg, #12365a 0%, #0b243d 100%)",
        borderRadius: "14px",
        p: 2.5,
        display: "flex",
        flexDirection: "column",
    };

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                {/* Cabeçalho */}
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard/Assinatura")}
                            >
                                <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Assinatura & Cobranças
                            </Link>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard/DetalhesCobranca")}
                            >
                                <DisplaySettingsIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Detalhes de Cobrança
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <PaymentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Método de Pagamento
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Alterar Método de Pagamento
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Escolha como deseja pagar sua assinatura. A alteração vale a partir da próxima cobrança.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                        {nomeMetodo(metodoAtual) && (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, backgroundColor: "#f3f4f6", borderRadius: "10px", px: 1.5, py: 1 }}>
                                <Box sx={{ width: 32, height: 32, borderRadius: "8px", backgroundColor: "#0b243d", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                    <PaymentIcon sx={{ color: "#ffc845", fontSize: 18 }} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Método atual</Typography>
                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{nomeMetodo(metodoAtual)}</Typography>
                                </Box>
                            </Box>
                        )}
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard/DetalhesCobranca")}
                            sx={botaoSecundarioSx}
                        >
                            Voltar
                        </Button>
                    </Box>
                </Box>

                {possuiFaturasEmAberto && (
                    <Box
                        sx={{
                            mt: 2,
                            display: "flex",
                            alignItems: { xs: "flex-start", sm: "center" },
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            gap: 1.5,
                            backgroundColor: "#fef3c7",
                            border: "1px solid #fde68a",
                            borderRadius: "12px",
                            px: 2,
                            py: 1.5,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "#b45309" }}>
                            <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
                            <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                Você tem faturas pendentes ou vencidas. Regularize sua situação para poder alterar o método de pagamento.
                            </Typography>
                        </Box>
                        <Button
                            onClick={() => navigate("../Dashboard/Faturas/Pendentes")}
                            sx={{ ...botaoPrincipalSx, flexShrink: 0, px: 2 }}
                        >
                            Ver faturas
                        </Button>
                    </Box>
                )}

                {/* Formulário */}
                <Box sx={{ ...cardSx, mt: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.5 }}>
                        <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                            <PaymentIcon sx={{ fontSize: 20 }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Forma de pagamento</Typography>
                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>Selecione a nova forma de cobrança da sua assinatura</Typography>
                        </Box>
                    </Box>

                    <RadioGroup
                        name="paymentMethod"
                        value={selectedValue}
                        onChange={handleChange}
                        sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1.5 }}
                    >
                        {OPCOES_PAGAMENTO.map(({ value, titulo, descricao, Icone, bandeiraCartao, ultimosDigitosCartao, mesValidadeCartao, anoValidadeCartao }) => {
                            const selecionado = selectedValue === value;
                            // Exibe o cartão cadastrado apenas quando o método atual da assinatura é cartão de crédito
                            const exibirCartao = value === "CREDIT_CARD" && metodoAtual === "CREDIT_CARD" && ultimosDigitosCartao;
                            return (
                                <FormControlLabel
                                    key={value}
                                    value={value}
                                    control={<Radio size="small" sx={{ "&.Mui-checked": { color: "#0b243d" } }} />}
                                    sx={{
                                        m: 0,
                                        p: 1.5,
                                        pr: 2,
                                        alignItems: "center",
                                        border: "1.5px solid",
                                        borderColor: selecionado ? "#ffc845" : "#e5e7eb",
                                        backgroundColor: selecionado ? "#fffbeb" : "#fff",
                                        borderRadius: "10px",
                                        transition: "border-color 0.15s, background-color 0.15s",
                                        "&:hover": { borderColor: selecionado ? "#ffc845" : "#d1d5db" },
                                        "& .MuiFormControlLabel-label": { flex: 1 },
                                    }}
                                    label={
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                            <Box
                                                sx={{
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: "8px",
                                                    flexShrink: 0,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: selecionado ? "#0b243d" : "#f3f4f6",
                                                    color: selecionado ? "#ffc845" : "#6b7280",
                                                    transition: "background-color 0.15s, color 0.15s",
                                                }}
                                            >
                                                <Icone sx={{ fontSize: 20 }} />
                                            </Box>
                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#111827" }}>
                                                        {titulo}
                                                    </Typography>
                                                    {metodoAtual === value && (
                                                        <Chip label="Atual" size="small" sx={{ height: 20, fontSize: 10, fontWeight: 700, backgroundColor: "#dcfce7", color: "#15803d" }} />
                                                    )}
                                                </Box>
                                                <Typography sx={{ fontSize: 12, color: "#6b7280", mt: 0.25 }}>
                                                    {descricao}
                                                </Typography>
                                                {exibirCartao && (
                                                    <Box
                                                        sx={{
                                                            mt: 1,
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 1,
                                                            flexWrap: "wrap",
                                                            backgroundColor: "#f3f4f6",
                                                            borderRadius: "6px",
                                                            px: 1,
                                                            py: 0.5,
                                                        }}
                                                    >
                                                        {bandeiraCartao && (
                                                            <Box sx={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.5, color: "#fff", backgroundColor: "#0b243d", borderRadius: "4px", px: 0.75, py: 0.25 }}>
                                                                {bandeiraCartao}
                                                            </Box>
                                                        )}
                                                        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#111827", fontFamily: "monospace" }}>
                                                            •••• {ultimosDigitosCartao}
                                                        </Typography>
                                                        {mesValidadeCartao && anoValidadeCartao && (
                                                            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>
                                                                Val. {mesValidadeCartao}/{anoValidadeCartao}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    }
                                />
                            );
                        })}
                    </RadioGroup>

                    {/* Dados do cartão */}
                    {selectedValue === "CREDIT_CARD" && (
                        <Box sx={{ mt: 3 }}>
                            <Typography sx={tituloSecaoSx}>{trocandoCartao ? "Dados do novo cartão" : "Dados do cartão"}</Typography>
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", md: "1fr 340px" },
                                    gap: 3,
                                    alignItems: "center",
                                    backgroundColor: "#f9fafb",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    p: { xs: 2, sm: 2.5 },
                                }}
                            >
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, "& .MuiOutlinedInput-root": { backgroundColor: "#fff", borderRadius: "8px", fontSize: 13 } }}>
                                    <TextField
                                        label="Nome no Cartão"
                                        fullWidth
                                        size="small"
                                        placeholder="Ex: João da Silva"
                                        name="name"
                                        value={cardData.name}
                                        onChange={handleCardInputChange}
                                        helperText={cardErrors.name}
                                        error={Boolean(cardErrors.name)}
                                    />

                                    <TextField
                                        label="Número do Cartão"
                                        fullWidth
                                        size="small"
                                        inputProps={{ maxLength: 19, inputMode: "numeric" }}
                                        placeholder="0000 0000 0000 0000"
                                        name="number"
                                        value={MascaraCartaoCredito(cardData.number)}
                                        onChange={handleCardInputChange}
                                        helperText={cardErrors.number}
                                        error={Boolean(cardErrors.number)}
                                    />

                                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
                                        <TextField
                                            label="Validade (MM/AAAA)"
                                            size="small"
                                            placeholder="MM/AAAA"
                                            inputProps={{ maxLength: 7, inputMode: "numeric" }}
                                            name="expiry"
                                            value={MascaraDataCartaoCredito(cardData.expiry)}
                                            onChange={handleCardInputChange}
                                            fullWidth
                                            helperText={cardErrors.expiry}
                                            error={Boolean(cardErrors.expiry)}
                                        />

                                        <TextField
                                            label="CVV"
                                            size="small"
                                            placeholder="123"
                                            inputProps={{ maxLength: 3, inputMode: "numeric" }}
                                            name="cvv"
                                            value={cardData.cvv}
                                            onChange={handleCardInputChange}
                                            onFocus={() => setShowBack(true)}  // mostra verso
                                            onBlur={() => setShowBack(false)}  // volta para frente
                                            fullWidth
                                            helperText={cardErrors.cvv}
                                            error={Boolean(cardErrors.cvv)}
                                        />
                                    </Box>
                                </Box>

                                {/* Cartão com efeito flip */}
                                <Box sx={{ display: { xs: "none", md: "block" }, perspective: "1000px", width: "100%", aspectRatio: "1.586" }}>
                                    <Box
                                        sx={{
                                            position: "relative",
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "14px",
                                            boxShadow: "0 10px 25px rgba(11,36,61,0.25)",
                                            color: "#fff",
                                            transition: "transform 0.6s",
                                            transformStyle: "preserve-3d",
                                            transform: showBack ? "rotateY(180deg)" : "rotateY(0deg)",
                                        }}
                                    >
                                        {/* Frente do cartão */}
                                        <Box sx={{ ...faceCartao, justifyContent: "space-between" }}>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <Box sx={{ width: 38, height: 28, borderRadius: "5px", background: "linear-gradient(135deg, #ffe08a, #ffc845)" }} />
                                                <CreditCardIcon sx={{ opacity: 0.7 }} />
                                            </Box>
                                            <Typography sx={{ fontFamily: "monospace", fontSize: 18, letterSpacing: 2 }}>
                                                {MascaraCartaoCredito(cardData.number) || "0000 0000 0000 0000"}
                                            </Typography>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                                                <Box sx={{ minWidth: 0 }}>
                                                    <Typography sx={{ fontSize: 9, opacity: 0.6, letterSpacing: 1 }}>TITULAR</Typography>
                                                    <Typography noWrap sx={{ fontFamily: "monospace", fontSize: 13, textTransform: "uppercase" }}>
                                                        {cardData.name || "NOME DO TITULAR"}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ flexShrink: 0 }}>
                                                    <Typography sx={{ fontSize: 9, opacity: 0.6, letterSpacing: 1 }}>VALIDADE</Typography>
                                                    <Typography sx={{ fontFamily: "monospace", fontSize: 13 }}>
                                                        {MascaraDataCartaoCredito(cardData.expiry) || "MM/AAAA"}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                        {/* Verso do cartão */}
                                        <Box sx={{ ...faceCartao, px: 0, justifyContent: "center", transform: "rotateY(180deg)" }}>
                                            <Box sx={{ background: "#000", height: 40, mb: 2.5 }} />
                                            <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1, px: 2.5 }}>
                                                <Typography sx={{ fontSize: 9, opacity: 0.6, letterSpacing: 1 }}>CVV</Typography>
                                                <Box sx={{ background: "#fff", color: "#111827", fontFamily: "monospace", px: 1.5, py: 0.5, borderRadius: "6px", fontWeight: 700, minWidth: 60, textAlign: "center" }}>
                                                    {cardData.cvv || "•••"}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}

                    {/* Ações */}
                    <Box
                        sx={{
                            mt: 3,
                            display: "flex",
                            flexDirection: { xs: "column-reverse", sm: "row" },
                            alignItems: { xs: "stretch", sm: "center" },
                            justifyContent: "space-between",
                            gap: 1.5,
                            backgroundColor: "#f3f4f6",
                            borderRadius: "8px",
                            px: 1.5,
                            py: 1,
                        }}
                    >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: "#6b7280", justifyContent: { xs: "center", sm: "flex-start" } }}>
                            <LockOutlinedIcon sx={{ fontSize: 16 }} />
                            <Typography sx={{ fontSize: 12 }}>Seus dados são transmitidos de forma segura.</Typography>
                        </Box>
                        <Button
                            variant="contained"
                            onClick={handleChangePaymentMethod}
                            disabled={
                                salvando ||
                                !selectedValue ||
                                possuiFaturasEmAberto ||
                                (trocandoCartao ? !cartaoPreenchido : selectedValue === metodoAtual)
                            }
                            sx={botaoPrincipalSx}
                        >
                            {salvando ? "Salvando..." : trocandoCartao ? "Salvar novo cartão" : "Salvar método de pagamento"}
                        </Button>
                    </Box>
                </Box>
            </Box>

            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
        </>
    );
};

export default MetodoPagamento;
